import React from "react";
import { Text } from "react-native";

export default class CustomText extends React.Component {

    render(){
        return(
            <Text
                allowFontScaling={true}
                {...this.props}
            >
                {this.props.children}
            </Text>
        )
    }
}
